import { render, staticRenderFns } from "./fivePoints.vue?vue&type=template&id=21dcdc7a&scoped=true"
import script from "./fivePoints.vue?vue&type=script&lang=js"
export * from "./fivePoints.vue?vue&type=script&lang=js"
import style0 from "./fivePoints.vue?vue&type=style&index=0&id=21dcdc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dcdc7a",
  null
  
)

export default component.exports